import React, { useEffect, useState } from 'react';
import { Button, Typography, CircularProgress } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getAccountAPI, updateAccount } from '../../actions/auth';
import LoadTextField from '../LoadTextField';
import _ from 'lodash';
import { updateUser } from '../../api';


function DetailsForm(props) {
  const dispatch = useDispatch();
  const accountRedux = useSelector(state => state.auth.account);
  const [account, setAccount] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setAccount(accountRedux);
  }, [accountRedux]);

  useEffect(() => {
    dispatch(getAccountAPI());
  }, [dispatch]);

  const handleChange = (key, val) => {
    setAccount({
      ...account,
      [key]: val
    });
  }

  const handleSubmit = evt => {
    evt.preventDefault();

    setSaving(true);
    const data = _.pick(account, ['firstName', 'lastName', 'email']);
    updateUser(account.id, data)
      .then(res => dispatch(updateAccount(res)))
      .catch(err => console.warn(err))
      .finally(() => setSaving(false));
  }

  const loading = account == null;

  return (
    <>
      <Typography variant="h6">Details</Typography>

      <form onSubmit={handleSubmit}>
        <LoadTextField
          label='First Name'
          value={account?.firstName}
          variant='outlined'
          loading={loading}
          margin='normal'
          autoComplete='given-name'
          onChange={evt => handleChange('firstName', evt.target.value)}
          fullWidth
          required
        />

        <LoadTextField
          label='Last Name'
          value={account?.lastName}
          variant='outlined'
          loading={loading}
          margin='normal'
          autoComplete='family-name'
          onChange={evt => handleChange('lastName', evt.target.value)}
          fullWidth
          required
        />

        <LoadTextField
          label='Email'
          value={account?.email}
          variant='outlined'
          loading={loading}
          margin='normal'
          autoComplete='email'
          onChange={evt => handleChange('email', evt.target.value)}
          fullWidth
          required
        />

        {saving
          ? <CircularProgress />
          : <Button
              variant="outlined"
              type="submit"
            >
              Save
            </Button>}
      </form>
    </>
  );
}

export default DetailsForm;